// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"3a6c1b5b","291":"f4f6ff68","680":"4bfedb99","787":"0857608a","939":"71966bc0"}[chunkId] + ".chunk.js";
};